import { SelectProps } from "antd";
import { FilterBy } from "shared/components/FilterByInput/FIlterByInput";
import { SelectValue } from "antd/lib/select";
import styles from "./Filter.module.scss";
import { SortedCheckSelect } from "shared/components/select/SortedCheckSelect";

type SelectCheckFilterProps<T> = {
  title: string;
  children?: never;
} & SelectProps<T>;

export const SelectCheckFilter = <T extends SelectValue>({
  title,
  ...rest
}: SelectCheckFilterProps<T>) => {
  return (
    <FilterBy title={title}>
      <SortedCheckSelect
        id={title}
        className={styles.filterInput}
        allowClear
        {...rest}
      />
    </FilterBy>
  );
};
